import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  Validators,
} from '@angular/forms';

import { UsersService } from 'src/services/users/users.service';
import { ModalService } from 'src/services/other/modal.service';

@Component({
  selector: 'app-reset-password-layout',
  templateUrl: './reset-password-layout.component.html',
  styleUrls: ['./reset-password-layout.component.css'],
})
export class ResetPasswordLayoutComponent implements OnInit {
  formLogin: FormGroup;
  isOnSubmit: boolean = false;
  isDisabled: boolean = false;
  hidePassword: boolean = true;
  userInformation: any;
  token: string;

  constructor(
    private router: Router,
    private formBuilder: FormBuilder,
    private loginService: UsersService,
    private modalService: ModalService,
    private userService: UsersService,
    private route: ActivatedRoute
  ) {
    this.formLogin = this.formBuilder.group({
      password: [
        '',
        [
          Validators.pattern(/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*\W).*$/),
          Validators.minLength(12),
          Validators.maxLength(20),
          Validators.required,
        ],
      ],

      password_confirm: ['', [this.matchPasswordValidator.bind(this)]],
    });
  }

  ngOnInit(): void {
    this.setupPasswordListeners();
    this.modalService.open('Loading');
    this.route.queryParams.subscribe((params) => {
      this.token = params['token'];
      this.userService.getResetOuthToken(this.token).subscribe({
        next: (res) => {
          this.userInformation = res.email;
          this.modalService.hide();
        },
        error: () => {
          this.modalService.isError(true, 'ErrorToken');
          setTimeout(() => {
            this.isOnSubmit = false;
            this.isDisabled = false;
            this.modalService.hide();
            this.router.navigate(['/login']);
          }, 3500);
        },
      });
    });
    // let code = this.route.snapshot.paramMap.get('token');
  }

  setupPasswordListeners() {
    const passwordControl = this.formLogin.get('password');
    if (passwordControl) {
      passwordControl.valueChanges.subscribe(() => {
        this.formLogin.get('password_confirm').updateValueAndValidity();
      });
    }
  }

  matchPasswordValidator(
    control: AbstractControl
  ): { [key: string]: boolean } | null {
    if (!this.formLogin) {
      return null;
    }

    const password = this.formLogin.get('password')?.value;
    const passwordConfirm = control.value;

    return password === passwordConfirm ? null : { passwordMismatch: true };
  }

  togglePasswordVisibility(): void {
    this.hidePassword = !this.hidePassword;
    const passwordInput = document.getElementById('password');
    if (passwordInput) {
      passwordInput.setAttribute(
        'type',
        this.hidePassword ? 'password' : 'text'
      );
    }
  }

  onSubmit() {
    this.isOnSubmit = true;
    this.isDisabled = true;
    let bodyToSend = {
      email: this.userInformation,
      token: this.token,
      ...this.formLogin.value,
    };

    if (this.formLogin.valid) {
      this.modalService.open('Loading');

      this.loginService.patchResetPassword(bodyToSend).subscribe({
        next: () => {
          this.modalService.isSuccess(true, 'Success');
          setTimeout(() => {
            this.isOnSubmit = false;
            this.isDisabled = false;
            this.modalService.hide();
            this.router.navigate(['/login']);
          }, 1500);
        },
        error: () => {
          this.modalService.isError(true, 'Error');
          setTimeout(() => {
            this.isOnSubmit = false;
            this.isDisabled = false;
            this.modalService.hide();
          }, 1200);
        },
      });
    } else {
      this.isDisabled = false;
    }
  }
}
